var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loggedIn)?_c('div',[_c('Overview')],1):_c('div',[_c('Welcome')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }